/**
 * This module was originally in bunsen and created by PeteJodo
 * Modified and relocated by Liliana on 12/22/15
 */

'use strict';

const $ = require('dibs-jquery-shim');
const Proxier = require('bunsen/helpers/Proxier');
const LocalCartCollection = require('bunsen/collections/portfolio/LocalCartCollection');
const ServiceCartCollection = require('bunsen/collections/portfolio/ServiceCartCollection');
const CartPortfolioItem = require('bunsen/models/portfolio/CartPortfolioItemModel');
const User = require('../../../../models/User');
const Clump = require('bunsen/libraries/clump');

let proxiedCart;
let localCart;
let serviceCart;

function saveLocalCartItems() {
    const saveComplete = $.Deferred();
    const clump = new Clump({ auto: true });
    $.when
        .apply($, localCart.models.reverse().map(cartItem => cartItem.save(null, { clump })))
        .then(saveComplete.resolve, resp => {
            // saving duplicate returns 409
            if (resp.status === 409) {
                saveComplete.resolve();
            } else {
                localCart.trigger('cart:error', 'error merging cart data');
                saveComplete.reject();
            }
        });
    return saveComplete;
}

function setToServiceCart() {
    return User.load().done(userData => {
        const portfolioItems = userData.cart.items || [];
        const models = [];
        let saveComplete;
        portfolioItems.forEach(portfolioItem => models.push(new CartPortfolioItem(portfolioItem)));
        if (localCart.length > 0) {
            models.push.apply(models, localCart.models);
            saveComplete = saveLocalCartItems();
        } else {
            saveComplete = $.Deferred().resolve();
        }
        saveComplete.done(() => {
            if (localCart.length > 0) {
                localCart.reset();
            }
            proxiedCart.__proxySwitch(serviceCart);
            serviceCart.reset(models);
            serviceCart.checkStaleData();
            proxiedCart.trigger('cart:ready');
        });
    });
}

function initCartCollection() {
    localCart = new LocalCartCollection();
    serviceCart = new ServiceCartCollection();
    proxiedCart = new Proxier(localCart, { preserveEvents: true });
    setToServiceCart();
    if (!User.loggedIn()) {
        $.subscribe('login:change', (e, data) => {
            if (data.loggedIn) {
                setToServiceCart();
            }
        });
    }
}

module.exports.getCartCollection = function() {
    if (!proxiedCart) {
        initCartCollection();
    }
    return proxiedCart;
};



// WEBPACK FOOTER //
// ./assets/js/global/core/nav/cart/collections/ProxiedCartCollection.es.js